import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from '@angular/router';
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from '../../../services/http-client.service';
import { WebClientService } from '../../../services/webclient-settings.service';
import { AuthService } from '../../../services/auth.service';
import { LanguageService } from "../../../services/language.service";
let WalletDocumentExpirationModalComponent = class WalletDocumentExpirationModalComponent {
    constructor(httpClient, sanitizer, router, location, themeService, webSettingsService, auth, languageService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.auth = auth;
        this.languageService = languageService;
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.backColor = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.types = [];
        this.filesToUpload = [];
        this.displayFiles = [];
        this.user = {};
        this.user_documents_submitted = false;
        this.sendButtonClicked = false;
        this.errorMessage = '';
        this.successMessage = false;
        this.documentTypeError = false;
        this.showDocumentTypes = false;
        if (localStorage.getItem('language') !== null)
            this.lang = localStorage.getItem('language');
        this.getVerificationSettings(this.lang);
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.user = JSON.parse(localStorage.getItem('user'));
        this.languageService.language.subscribe((language) => {
            this.getVerificationSettings(language);
        });
        this.getDocumentTypes();
    }
    getDocumentTypes() {
        this.httpClient.get('user/verificationdocumenttypes').subscribe((data) => {
            this.types = data;
        }, (error) => {
        });
    }
    close() {
        this.modal.destroy();
    }
    expandTypes() {
        this.typeExpanded = !this.typeExpanded;
    }
    fillType(id, lang_code) {
        this.documentType = this.webSettingsService.getKeyValue(lang_code);
        this.selectedTypeId = id;
        this.checkDocumentType();
    }
    checkDocumentType() {
        if (this.selectedTypeId == "null" || this.selectedTypeId === undefined) {
            this.documentTypeError = true;
        }
        else {
            this.documentTypeError = false;
        }
    }
    fileChange(event) {
        this.filesToUpload = event.target.files;
        this.displayFiles = this.toArray(this.displayFiles).concat(this.toArray(this.filesToUpload));
        for (let i = 0; i < this.displayFiles.length; i++) {
            let fileExtension = this.displayFiles[i].name.split('.').pop();
            let allowed = this.checkFileExtension(fileExtension);
            if (this.displayFiles[i].size > 1024 * 1024 * this.fileSize || !allowed) {
                this.fileSizeError = true;
                break;
            }
            else {
                this.fileSizeError = false;
            }
        }
    }
    removeFile(file) {
        if (this.displayFiles.length === 1) {
            this.displayFiles = [];
        }
        else {
            for (let i = 0; i < this.displayFiles.length; i++) {
                if (this.displayFiles[i].name === file.name) {
                    this.displayFiles.splice(i, 1);
                }
            }
        }
        this.validateFiles();
    }
    validateFiles() {
        for (let i = 0; i < this.displayFiles.length; i++) {
            if (this.displayFiles[i].size > 1024 * 1024 * this.fileSize) {
                this.fileSizeError = true;
                break;
            }
            else {
                this.fileSizeError = false;
            }
        }
        if (this.displayFiles.length == 0) {
            this.fileSizeError = false;
        }
    }
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.sendButtonClicked = true;
            this.validateFiles();
            if (this.user_documents_submitted || this.fileSizeError || this.displayFiles.length > this.numberOfFiles || this.displayFiles.length <= 0 || this.documentTypeError || !this.selectedTypeId) {
                this.sendButtonClicked = false;
                this.successMessage = false;
            }
            let formData = new FormData();
            const files = this.displayFiles;
            for (let i = 0; i < files.length; i++) {
                formData.append(files[i].name, files[i]);
            }
            let documentationFiles = [];
            const readUploadedFileAsDataURL = (file) => {
                const temporaryFileReader = new FileReader();
                return new Promise((resolve) => {
                    temporaryFileReader.onload = () => {
                        resolve(temporaryFileReader.result);
                        const tempFile = {
                            name: file.name,
                            content: temporaryFileReader.result
                        };
                        documentationFiles.push(tempFile);
                    };
                    temporaryFileReader.readAsDataURL(file);
                });
            };
            for (let i = 0; i < files.length; i++) {
                yield readUploadedFileAsDataURL(files[i]);
            }
            if (this.sendButtonClicked) {
                this.httpClient.post('user/userpersonaldocumentation', {
                    user_id: this.user.id,
                    document_type_id: this.selectedTypeId,
                    documentation_files: documentationFiles
                }).subscribe((success) => {
                    this.user_documents_submitted = true;
                    this.sendButtonClicked = false;
                    this.successMessage = true;
                }, (error) => {
                    this.sendButtonClicked = false;
                    this.errorMessage = error.error['message'];
                });
            }
        });
    }
    getVerificationSettings(lang) {
        this.webSettingsService.getSettings().subscribe((data) => {
            const size = this.webSettingsService.getCustomValue('VERIFY.ALLOWED_VERIFICATION_FILE_SIZE.VALUE');
            const parsedSize = parseInt(size);
            this.fileSize = (size !== '' && parsedSize) ? parsedSize : 0;
            const nmb = this.webSettingsService.getCustomValue('VERIFY.NUMBER_OF_VERIFICATION_FILES.VALUE');
            const parsedNumber = parseInt(nmb);
            this.numberOfFiles = (nmb !== '' && parsedNumber) ? parsedNumber : 0;
        });
    }
    toArray(fileList) {
        return Array.prototype.slice.call(fileList);
    }
    checkFileExtension(fileExtension) {
        let allowedExtensions = ['jpg', 'png', 'jpeg', 'pdf', 'gif', 'JPG', 'JPEG', 'PNG', 'PDF', 'GIF'];
        let allowed = allowedExtensions.includes(fileExtension);
        return allowed;
    }
};
WalletDocumentExpirationModalComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: AuthService },
    { type: LanguageService }
];
WalletDocumentExpirationModalComponent = __decorate([
    Component({
        selector: 'ecd-wallet-document-expiration-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./wallet-document-expiration-modal.component.html")).default,
    })
], WalletDocumentExpirationModalComponent);
export { WalletDocumentExpirationModalComponent };
